module.exports = __webpack_public_path__ + "img/wire-instructions-icon.f93ec3c4.svg";